"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getAuthStateKeysFromAll = exports.getAuthStateKeysFromCookies = exports.getAuthStateKeysFromLocalStorage = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _lodash = _interopRequireDefault(require("lodash"));
var _clientStorage = require("../clientStorage");
var _isStringAuthStateKey = _interopRequireDefault(require("./isStringAuthStateKey"));

/**
 * get an array containing all of the auth state keys found in local storage
 */
var getAuthStateKeysFromLocalStorage = function getAuthStateKeysFromLocalStorage() {
  var stateKeys = _lodash.default.reduce(Object.keys(window.localStorage), function (accumulator, key) {
    return (0, _isStringAuthStateKey.default)(key) // if its an auth state key add it to accumulator
    ? [].concat((0, _toConsumableArray2.default)(accumulator), [key]) // else return accumulator
    : accumulator;
  }, []);
  return stateKeys;
};
/**
 * get an array containing all of the auth state keys found in cookies
 */

exports.getAuthStateKeysFromLocalStorage = getAuthStateKeysFromLocalStorage;
var getAuthStateKeysFromCookies = function getAuthStateKeysFromCookies() {
  var allCookies = document.cookie.split(/; */);
  var stateKeys = _lodash.default.reduce(allCookies, function (accumulator, cookieString) {
    var _cookieString$split = cookieString.split('='),
      _cookieString$split2 = (0, _slicedToArray2.default)(_cookieString$split, 1),
      name = _cookieString$split2[0];
    return (0, _isStringAuthStateKey.default)(name) ? [].concat((0, _toConsumableArray2.default)(accumulator), [name]) : accumulator;
  }, []);
  return stateKeys;
};
/**
 * Check all supported storage types for auth state keys
 */

exports.getAuthStateKeysFromCookies = getAuthStateKeysFromCookies;
var getAuthStateKeysFromAll = function getAuthStateKeysFromAll() {
  var authStateKeys = [].concat((0, _toConsumableArray2.default)(getAuthStateKeysFromLocalStorage()), (0, _toConsumableArray2.default)(getAuthStateKeysFromCookies()));
  return authStateKeys;
};
/**
 *
 * @param {*} clientStorageType
 */

exports.getAuthStateKeysFromAll = getAuthStateKeysFromAll;
var getAuthStateKeys = function getAuthStateKeys(clientStorageType) {
  switch (clientStorageType) {
    case _clientStorage.CLIENT_STORAGE_COOKIES:
      return getAuthStateKeysFromCookies();
    case _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE:
      return getAuthStateKeysFromLocalStorage();
    case _clientStorage.CLIENT_STORAGE_ALL:
    default:
      return getAuthStateKeysFromAll();
  }
};
var _default = getAuthStateKeys;
exports.default = _default;